import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InboxOutlined } from "@ant-design/icons";
import { App, Form, Upload } from "antd";
import { useCallback } from "react";
import { ESupportTicketAllowedAttachmentTypes, ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { __ } from "../../utils/i18n.js";
const MAX_FILES = 10;
const MAX_FILE_SIZE_MB = 30;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
const SupportFormUploadField = ()=>{
    const { message } = App.useApp();
    const getValueFromEvent = useCallback((e)=>{
        const fileList = (Array.isArray(e) ? e : e && e.fileList).filter((param)=>{
            let { size } = param;
            if (size > MAX_FILE_SIZE) {
                message.error(__("One or more files exceed the maximum size of %d MB", MAX_FILE_SIZE_MB));
                return false;
            }
            return true;
        });
        return fileList;
    }, []);
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.attachments.length !== nextValues.attachments.length || prevValues.questionType !== nextValues.questionType,
        children: (param)=>{
            let { getFieldValue } = param;
            const questionType = getFieldValue("questionType");
            const attachments = getFieldValue("attachments");
            if (questionType === ESupportTicketQuestionType.RequestCustomOffer) {
                return null;
            }
            return /*#__PURE__*/ _jsx(Form.Item, {
                label: __("Attachments"),
                name: "attachments",
                valuePropName: "fileList",
                getValueFromEvent: getValueFromEvent,
                children: /*#__PURE__*/ _jsxs(Upload.Dragger, {
                    accept: Object.values(ESupportTicketAllowedAttachmentTypes).join(","),
                    beforeUpload: ()=>false,
                    maxCount: MAX_FILES,
                    openFileDialogOnClick: attachments.length < MAX_FILES,
                    multiple: true,
                    style: {
                        cursor: attachments.length >= MAX_FILES ? "initial" : undefined
                    },
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: `${process.env.ANTD_PREFIX}-upload-drag-icon`,
                            children: /*#__PURE__*/ _jsx(InboxOutlined, {})
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: `${process.env.ANTD_PREFIX}-upload-text`,
                            children: attachments.length >= MAX_FILES ? __("You have reached the maximum of %d files", MAX_FILES) : __("Click or drag file to this area to upload")
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: `${process.env.ANTD_PREFIX}-upload-hint`,
                            children: [
                                __("The maximum allowed upload size is %d MB per file.", MAX_FILE_SIZE_MB),
                                /*#__PURE__*/ _jsx("br", {}),
                                __("Allowed file types: Images, PDFs, ZIP archives and videos.")
                            ]
                        })
                    ]
                })
            });
        }
    });
};
export { SupportFormUploadField };
